/* eslint-disable */
import request from './helpers'

export function listCluster () {
    return request ({
        url: '/api/v1/manage/kafka_cluster/list',
        method: 'get'
    })
}

export function searchClusterByTags (tags) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/search/by_tags',
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
            tags
        }
    })
}

export function listChannelWithCredential () {
    return request ({
        url: '/api/v1/manage/kafka_cluster/list_with_credential',
        method: 'get'
    })
}
export function createCluster (data) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/create',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function resetCluster (data) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/reset',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function updateCluster (data) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/update',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function activeCluster (id, active) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/' + id + '/status',
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            active
        }
    })
}

export function deleteCluster (id) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/' + id + '/delete',
        method: 'delete'
    })
}

export function uploadSSL (data) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/upload/truststore',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function getClusterById (id) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/' + id + '/console_detail',
        method: 'get'
    })
}

export function uploadFromMq (data) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/upload_from_asyncmq',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            uploadClusterFromAsyncMQParams: data
        }
    })
}

export function getBrokerConfig (id, brokerId) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/' + id + '/' + brokerId + '/describe_config',
        method: 'get'
    })
}

export function describeBrokerAllConfig (id, brokerId) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/' + id + '/' + brokerId + '/describe_all_config',
        method: 'get'
    })
}

export function getBrokerLogDir (id, brokerId) {
    return request ({
        url: '/api/v1/manage/kafka_cluster/' + id + '/' + brokerId + '/list_broker_log_dir',
        method: 'get'
    })
}

export function listBrokerConfigItems() {
    return request({
        url: '/api/v1/manage/kafka_cluster/list/default_config',
        method: 'get'
    })
}

export function updateConfigBrokers(id, configs) {
    return request({
        url: '/api/v1/manage/kafka_cluster/' + id + '/update_config',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            configs
        }
    })
}

export function getClusterTopics (id) {
    return request ({
        url: '/api/v1/manage/kafka_topic/' + id + '/list',
        method: 'get'
    })
}

export function getTopicDescribe (id, topicUrl) {
    return request ({
        url: '/api/v1/manage/kafka_topic/' + id + '/' + topicUrl + '/describe',
        method: 'get'
    })
}

export function getTopicLogdir (id, topicUrl, params) {
    return request ({
        url: '/api/v1/manage/kafka_topic/' + id + '/' + topicUrl + '/describe/log_dir',
        method: 'get',
        params
    })
}

export function getTopicTask (id, params) {
    return request ({
        url: '/api/v1/manage/kafka_topic/' + id + '/query_task',
        method: 'get',
        params
    })
}

export function listTopicConfigItems() {
    return request({
        url: '/api/v1/manage/kafka_topic/list/topic_configs',
        method: 'get'
    })
}

export function createTopic(data) {
    return request({
        url: '/api/v1/manage/kafka_topic/create',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateTopic(data) {
    return request({
        url: '/api/v1/manage/kafka_topic/update/config',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function deleteTopic(id, topicUrl) {
    return request({
        url: '/api/v1/manage/kafka_topic/delete/' + id + '/' + topicUrl,
        method: 'delete'
    })
}

export function addPartition(data) {
    return request({
        url: '/api/v1/manage/kafka_topic/expand/partitions',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function electPreferredLeaders(id, topicUrl) {
    return request({
        url: '/api/v1/manage/kafka_topic/' + id + '/' + topicUrl + '/elect/preferred_leader',
        method: 'get'
    })
}

export function getClusterGroups (id) {
    return request ({
        url: '/api/v1/manage/kafka_consumer/' + id + '/list',
        method: 'get'
    })
}

export function getGroupDescribe (id, groupId) {
    return request ({
        url: '/api/v1/manage/kafka_consumer/' + id + '/' + groupId + '/group/describe',
        method: 'get'
    })
}

export function resetGroupRemain (id, data) {
    return request ({
        url: '/api/v1/manage/kafka_consumer/' + id + '/reset/remain',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function downloadTopics(id, params) {
    return request({
        url: '/api/v1/manage/kafka_topic/' + id + '/export/topic_view',
        method: 'get',
        responseType: 'blob',
        params
    })
}

export function downloadGroups(id, params) {
    return request({
        url: '/api/v1/manage/kafka_consumer/' + id + '/export/group_view',
        method: 'get',
        responseType: 'blob',
        params
    })
}

export function createAcl(data) {
    return request({
        url: '/api/v1/manage/kafka_topic/acl/create',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function deleteAcl(data) {
    return request({
        url: '/api/v1/manage/kafka_topic/acl/delete',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function getAcl(data) {
    return request({
        url: '/api/v1/manage/kafka_topic/acl/describe',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function alterTopicLogDirs(data) {
    return request({
        url: '/api/v1/manage/kafka_topic/alter/log_dir',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function deleteGroup(id, groupId) {
    return request({
        url: '/api/v1/manage/kafka_consumer/' + id + '/' + groupId + '/group/delete',
        method: 'delete'
    })
}

export function deleteTopicRecord(data) {
    return request({
        url: '/api/v1/manage/kafka_topic/topic_records/delete',
        method: 'delete',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
